module.exports = __webpack_public_path__ + "img/iphone-hero-bg.c36f1e56.svg";